import { createBlueprint as e } from "@made-people/blueprint";
const a = e({
  slots: {
    base: "flex flex-col group/blog-teaser",
    badge: "text-body-sm rounded-full px-2 py-1",
    badges: "absolute z-10 flex gap-2",
    image: "aspect-square object-cover rounded-xl w-full h-full flex",
    imageWrapper: "aspect-square rounded-xl relative mb-6 overflow-hidden",
    contentWrapper: "",
    tags: "flex gap-2 items-center mb-4 px-3",
    tag: "text-body-sm",
    tagsSeparatorDot: "w-1 h-1 bg-black rounded-full",
    heading: "text-heading-xs mb-4 px-3",
    text: "text-body-sm line-clamp-2 mb-4 px-3",
    link: "text-heading-2xs w-fit ml-3"
  },
  variants: {
    badgeColor: {
      primary: {
        badge: "bg-black text-white"
      },
      secondary: {
        badge: "bg-white text-black"
      },
      black: {
        badge: "bg-black text-white"
      },
      white: {
        badge: "bg-white text-black"
      }
    },
    badgePosition: {
      topRight: {
        badges: "top-3 right-3"
      },
      topLeft: {
        badges: "top-3 left-3"
      },
      bottomRight: {
        badges: "bottom-3 right-3"
      },
      bottomLeft: {
        badges: "bottom-3 left-3"
      }
    },
    hasUnderlineAnimation: {
      true: {
        link: "relative after:bg-black after:absolute after:bottom-0 after:content after:h-[1px] after:bg-black after:transition-all after:scale-x-0 after:origin-left after:duration-[0.7s] after:ease-[cubic-bezier(.19,1,.22,1)] group-hover/blog-teaser:after:scale-x-100 after:w-full after:block"
      }
    },
    scaleImageOnHover: {
      true: {
        image: "group-hover/blog-teaser:scale-105 transition-transform duration-300"
      }
    }
  },
  defaultVariants: {
    badgeColor: "primary",
    scaleImageOnHover: "true",
    badgePosition: "topLeft",
    hasUnderlineAnimation: "true"
  }
});
export {
  a as blogTeaserStyling
};
//# sourceMappingURL=index-blueprint.es.js.map
